export default {
  service: null,
  recentUsers: [],
  favoriteUsers: [],
  opsToggles: [],
  authenticatedUser: null,
};
